import Portfolio3GridContainer from "../../../../components/pages/portfolio/portfolioPage/Portfolio3Grid";

const Portfolio3Grid = () => {
  return <Portfolio3GridContainer />;
};

export default Portfolio3Grid;
